module.exports = "/_next/static/images/landing-hero-mobile-b58df73c4dc0c190b29b41b1e215454f.png.webp";